import { Component, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { TelephoneLinkComponent } from '../../../../../../../../../../../../shared/components/telephone-link/telephone-link.component';

@Component({
  selector: 'app-remedial-work',
  imports: [DotPulseComponent, TelephoneLinkComponent],
  providers: [],
  templateUrl: './remedial-work.component.html',
  styleUrl: './remedial-work.component.scss',
})
export class RemedialWorkComponent {
  claimType = input.required<'repair' | 'service'>();
}
